var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgMiconButtonGroup = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 32,
  height: 32,
  fill: "none",
  viewBox: "0 0 32 32"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "currentcolor",
  d: "M22 21v-1a1 1 0 0 1 2 0v10h2V20a3.004 3.004 0 0 0-3-3 2.96 2.96 0 0 0-1.47.401 2.954 2.954 0 0 0-4-1A3 3 0 0 0 15 15a3 3 0 0 0-1 .185V10a3 3 0 0 0-6 0v11.105l-2.235-1.53v.001a3 3 0 0 0-3.881 4.55L8.323 30l1.348-1.478-6.38-5.818a.99.99 0 0 1-.141-1.23A1 1 0 0 1 4.6 21.2l5.4 3.696V10a1 1 0 0 1 2 0v11h2v-3a1 1 0 0 1 2 0v3h2v-2a1 1 0 0 1 2 0v2z"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  fill: "currentcolor",
  fillRule: "evenodd",
  d: "M2 4a2 2 0 0 1 2-2h9a2 2 0 0 1 2 2v3l-2-1V4H4v6h1.5v2H4a2 2 0 0 1-2-2z",
  clipRule: "evenodd"
})), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
  stroke: "currentcolor",
  strokeLinejoin: "round",
  strokeWidth: 2,
  d: "M18 3h11v8H18z"
})));
export default SvgMiconButtonGroup;